{
  "w": 16,
  "h": 10,
  "rows": [
    ".....KKwwwK.....",
    "....KKwwwwwK....",
    ".KKKKWWWWWWWK...",
    "KwwKwwwwwwKKwKK.",
    "KWWKwwwwwKWWWWWK",
    "wwwKwwwwKwwwwwwK",
    "wwwwKwwwKwwwwwww",
    "wwwwKwwwKwwwKwwK",
    "KwwKwKwwwKwwwwwK",
    ".KKKKKKKKKKKKKK."
  ],
  "legend": {
    "K": "C.BLACK",
    "W": "C.B_WHITE",
    "w": "C.WHITE"
  }
}
